let resourceMap = null;

export function setResourceMap(map) {
  if (!map || typeof map !== 'object') throw new Error('Invalid resource map');
  resourceMap = map;
}

export function getResourceMap(type) {
  if (!resourceMap) throw new Error('resourceMap not initialized');
  if (!type) return resourceMap;
  const Model = resourceMap[type];
  if (!Model) throw new Error(`Unknown resource type: ${JSON.stringify(type)}`);
  return Model;
}
